import nodeApi from '../utils/nodeApiClient';

const reportsApi = {
  run: (params) => nodeApi.get('/reports', { params })
};

export default reportsApi;
